import { render, staticRenderFns } from "./item-price-chart.vue?vue&type=template&id=dcfd73d6"
import script from "./item-price-chart.vue?vue&type=script&lang=js"
export * from "./item-price-chart.vue?vue&type=script&lang=js"
import style0 from "./item-price-chart.vue?vue&type=style&index=0&id=dcfd73d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports